<template>
    <div>
        <PCNavbar></PCNavbar>
        <CarouselHome type="about" />
        <div class="main-wrap" style="height: auto;">
            <div class="block-wrap" style="height: auto;">
                <div class="tab">
                    <div class="tab-item" v-for="(item, index) in config.about_cifu" :class="{ current: current == item.id }" :key="index" @click="toggle(item.id)">
                        {{ item.name }}
                    </div>
                </div>
                <div class="article look about-content" style="background-color: white;width: 100%;">
                    <div class="content">
                        <p>{{ cname }}</p>
                        <div v-html="aboutContent" class="about-content"></div>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
    import CifuAPI from "@/utils/api";
    import { mapState } from "vuex";
    import { baseURL } from "@/utils/http";
    import PCNavbar from "@/components/navbar/index";
    import CarouselHome from "@/components/carousel_home/index";
    import Footer from "@/components/footer/index";
    export default {
        name: "Information",
        components: { PCNavbar, CarouselHome, Footer },
        data() {
            return {
                baseURL,
                current: 278,
                about_cifu: [],
                aboutContent: '',
                cname: '',
                dialogVisible: false,
            };
        },
        created() {
            this.$watch(
                "$route",
                (to) => {
                    const index = to.params.id || 1;
                    this.toggle(index);
                },
                { immediate: true }
            );
        },
        computed: {
            ...mapState(["config"]),
        },
        methods: {
            async toggle(index) {
                console.log(index)
                this.current = index;
                let contentIndex = this.config.about_cifu.findIndex(item => item.id == index)
                let res = await CifuAPI.getArticleDetail({
                    unicode: this.config.about_cifu[contentIndex].urlname
                })
                if (res.code == 1) {
                    this.aboutContent = res.data.content;
                    this.cname = res.data.cname
                }
                this.$store.dispatch("setMenuActive", "/about/" + index);
                // 更新路由参数
                this.$router.push({
                    path: `/about/${index}`
                });
            },
        }
    }
</script>

<style lang="scss" scoped>
.about-content {
  // 确保内容区域有足够的空间显示图片
  overflow: visible;
  
  // 图片容器样式
  ::v-deep img {
    max-width: none !important;
    width: auto !important;
    height: auto !important;
    object-fit: contain !important;
    object-position: center !important;
    margin: 10px 0;
    display: block;
    
    // 防止图片被压缩
    image-rendering: -webkit-optimize-contrast;
    image-rendering: crisp-edges;
    image-rendering: pixelated;
    
    // 确保图片清晰度
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  
  // 图片链接样式
  ::v-deep a img {
    border: none;
    outline: none;
  }
  
  // 响应式图片处理
  @media screen and (max-width: 768px) {
    ::v-deep img {
      max-width: 100% !important;
      width: 100% !important;
      height: auto !important;
    }
    ::v-deep .about-content>p>span{
        font-size: 14px !important;
    }
  }
  ::v-deep .content{
    padding: 50px 0 !important;
    font-size: 18px !important;
    color: #828282 !important;
    line-height: 32px !important;
  }
  ::v-deep .MsoNormal{
    background-image: initial !important;
    background-position: initial !important;
    background-size: initial !important;
    background-repeat: initial !important;
    background-attachment: initial !important;
    background-origin: initial !important;
    background-clip: initial !important;
    font-size: 18px !important;
  }
}
</style>